
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"27.105","height":"27.105"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Delay_for","data-name":"Delay for","transform":"translate(-1171.75 -313.105)","fill":"none","stroke":"#6d7f93","stroke-miterlimit":"10","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_920","data-name":"Path 920","d":"M210.6.5a12.8 12.8 0 1012.8 12.8A12.817 12.817 0 00210.6.5z","transform":"translate(974.702 313.355)"}}),_c('path',{attrs:{"id":"Path_919","data-name":"Path 919","d":"M217.055 10.242v5.95a.99.99 0 00.4.793l3.967 2.975","transform":"translate(968.431 309.945)","stroke-linecap":"round"}})])])
          )
        }
      }
    